module.exports = __webpack_public_path__ + "3913feebb10adb768180f57e6f13f539.svg";